import React, {Component} from 'react';

import {Dialog} from '../../../widgets';
import {connect} from 'react-redux';
import {uiActions} from '../../../chrome';
import './CouponStatistics.css';

import {getCouponStatistics} from '../coupons.selector';

import UserCardCouponRedeem from '../../../profile/UserCardCouponRedeem';

class CouponStatistics extends Component {
	render() {
		let couponStatistics = getCouponStatistics(this.props);
		let subscriptionList = couponStatistics[0] && couponStatistics[0].redeemedCoupons;
		let totalRedeemed = couponStatistics[0] && couponStatistics[0].totalRedeemed;
		let totalQuantity = couponStatistics[0] && couponStatistics[0].quantity;

		const {onSave, onCancel, session} = this.props;

		return (
			<Dialog
				title="Promotion Statistics"
				submitOnEnter={false}
				onSave={onSave}
				onCancel={onCancel}
				className="promotionStatistics"
				buttons={[]}>
				<div className="stistics">
					<div className="totalCoupons">
						<div>
							<span>{totalQuantity}</span>
							<span>Total Coupons</span>
						</div>
					</div>
					<div className="totalRedeemed">
						<div>
							<span>{totalRedeemed}</span>
							<span>Total Redeemed</span>
						</div>
					</div>
				</div>
				<div className="redeemtionList">
					{subscriptionList && subscriptionList.length > 0 ? (
						<ul className="userRedeemedList">
							{subscriptionList &&
								subscriptionList.map(user => (
									<UserCardCouponRedeem key={user && user.uuid} profile={user} />
								))}
						</ul>
					) : (
						<div className="notRedeemedYet">
							<span>Promotion has not been redeemed yet</span>
						</div>
					)}
				</div>
			</Dialog>
		);
	}
}

const mapStateToProps = state => {
	return {
		session: state.session,
		source: state.coupon.couponStatisticsSource,
		couponUuid: state.coupon.couponUuidForStatistics,
		profileCoupons: state.profileCoupon.coupons,
		communityCoupons: state.coupon.communityCoupons
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onSave: () => {},
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CouponStatistics);



// WEBPACK FOOTER //
// ./src/community/coupons/coupon-statistics/CouponStatistics.js